import React, { Component } from 'react';
import { Link } from 'react-router';
import './GankaoApp.css';
import { Helmet } from 'react-helmet';

export default class WordList extends Component {
    constructor(props) {
        super(props)
        this.bishun_data = window.AllBooksForPress;
        // console.log(this.bishun_data);
        this.state = {
            srcString: 'http://www.gankao.com/p-lubo/tag/tbsz',
        }
    }

    componentDidMount() {
        //跨域
        if (document.domain != 'gankao.com') {
            document.domain = 'gankao.com'
        }
    }

    render() {
        return (
            <div className="bookListBox">
                <Helmet title="笔顺书法" />
                <ul className="topNav container" id="nav">
                    <li>
                        <Link to={`/WordDetail`} activeClassName="active">汉字笔顺</Link>
                    </li>
                    <li>
                        <Link to={`/TongBuShuFa`} activeClassName="active">同步笔顺</Link>
                    </li>
                    <li>
                        <Link to={`/TongBu`} activeClassName="active">同步书法</Link>
                    </li>
                </ul>
                {this.props.children && this.props.children}
                {!this.props.children &&
                    <div>
                        {this.bishun_data.map((item, index) => {
                            return <Link key={"press" + index} to={`/press/${item.presspinyin}`}>
                                <div className="pressItem">
                                    {item.pressname}
                                </div>
                            </Link>
                        })}
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/gankaoapp/GankaoApp.js